import { useState, useCallback } from "react";
import { buildFieldTriggers, buildPreloadedValues } from "../utils";

const useFormPreloaders = () => {
    const [clientValues, setClientValues] = useState({});
    const [fieldTriggers, setFieldTriggers] = useState({});
    const [preloadersData, setPreloadersData] = useState({
        system: {
            "@today": new Date(),
            // Constante booleana: se guarda como string porque getFormattedFieldValue
            // la convierte a booleano comparando contra "true".
            "@true": "true",
        },
        client: undefined,
        attorneyUser: undefined,
        docIssuer: undefined,
    });

    const loadClientPreloader = useCallback((clientId, FormClients) => {
        FormClients.preloaders.getClientById({
            id: clientId,
            onSuccess: (data) => setPreloadersData((prev) => ({ ...prev, client: data })),
            onError: () => setPreloadersData((prev) => ({ ...prev, client: undefined })),
        });
    }, []);

    const setAttorneyPreloader = useCallback((attorneyUserData) => {
        setPreloadersData((prev) => ({ ...prev, attorneyUser: attorneyUserData }));
    }, []);

    const loadDocIssuerPreloader = useCallback(async (InvoicingIssuers) => {
        try {
            const data = await InvoicingIssuers.getAsync();
            setPreloadersData((prev) => ({ ...prev, docIssuer: data }));
        } catch {
            setPreloadersData((prev) => ({ ...prev, docIssuer: undefined }));
        }
    }, []);

    const initFieldTriggers = useCallback((formFieldMappings) => {
        setFieldTriggers(buildFieldTriggers(formFieldMappings));
    }, []);

    const preloadData = useCallback(
        (formFieldMappings) => {
            const cValues = buildPreloadedValues(formFieldMappings, preloadersData);
            setClientValues(cValues);
        },
        [preloadersData],
    );

    return {
        clientValues,
        fieldTriggers,
        preloadersData,
        loadClientPreloader,
        setAttorneyPreloader,
        loadDocIssuerPreloader,
        initFieldTriggers,
        preloadData,
    };
};

export default useFormPreloaders;
